var HeaderDynamicRegion = Marionette.Region.extend({
    constructor: function () {
        Marionette.Region.prototype.constructor.apply(this, arguments);
    }
});
module.exports = HeaderDynamicRegion;



/** WEBPACK FOOTER **
 ** ./assets/js/common/header-control-bar/header-dynamic-region.js
 **/